<template>
  <div class="k-card">
    <b-overlay
      :show="loading"
      rounded="lg"
      :opacity="1"
      no-fade
      variant="white"
    >
      <div v-if="hasBadgeSlot" class="k-card-badge">
        <slot name="badge"></slot>
      </div>
      <div v-if="hasSecondBadgeSlot" class="k-card-second-badge">
        <slot name="second-badge"></slot>
      </div>
      <div class="wrapper v-center">
        <div>
          <h2 v-if="hasTitleSlot">
            <slot name="title"></slot>
          </h2>
          <div class="desc" v-if="hasDescriptionSlot">
            <slot name="description"></slot>
          </div>
        </div>
      </div>
      <b-collapse v-if="collapsible" v-model="expanded" class="content">
        <div :class="expanded ? 'tborder' : null" class="ptb20">
          <slot name="content"> </slot>
        </div>
      </b-collapse>
      <div v-if="collapsible" class="bpane tborder p20">
        <slot name="buttons">
          <div v-if="!expanded">
            <b-button variant="primary" @click="expanded = !expanded">{{
              $t("button.edit")
            }}</b-button>
          </div>
          <div v-else class="buttons">
            <b-button variant="outline-secondary" @click="close()">{{
              $t("button.cancel")
            }}</b-button>
            <b-button
              variant="primary"
              @click="handleSaveClick()"
              :disabled="!changed"
              >{{ $t("button.save") }}</b-button
            >
          </div>
        </slot>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: "CollapsibleCard",
  data() {
    return {
      expanded: false,
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    collapsible: {
      type: Boolean,
      default: true,
    },
    changed: {
      type: Boolean,
      default: false,
    },
    noCloseOnOk: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasTitleSlot() {
      return !!this.$slots["title"];
    },
    hasDescriptionSlot() {
      return !!this.$slots["description"];
    },
    hasBadgeSlot() {
      return !!this.$slots["badge"];
    },
    hasSecondBadgeSlot() {
      return !!this.$slots["second-badge"];
    }
  },
  methods: {
    handleSaveClick() {
      if (!this.noCloseOnOk) this.close();
      this.$emit('click')
    },
    close() {
      this.$emit('close')
      this.expanded = false;
    }
  }
};
</script>

<style scoped>
.k-card {
  border: var(--default-border);
  border-radius: var(--default-border-radius);
}
.k-card-badge {
  position: absolute;
  top: calc(-0.5rem - 0.2em);
  left: calc(32px - 7px);
  font-weight: 400;
  padding: 0 0.5em;
  border-radius: 0.25rem;
  background-color: white;
}
.k-card-second-badge {
  position: absolute;
  top: calc(-0.5rem - 0.2em);
  right: calc(32px - 7px);
  font-weight: 400;
  padding: 0 0.5em;
  border-radius: 0.25rem;
  background-color: white;
  z-index: 100;
}
.k-card:not(:first-child) {
  margin-top: 32px;
}
.k-card .wrapper {
  padding: 32px;
}
@media screen and (max-width: 768px) {
  .k-card-badge {
    font-size: 90%;
  }
  .k-card-second-badge {
    font-size: 90%;
  }
}
@media screen and (max-width: 490px) {
  .k-card .wrapper {
    padding: 32px 18px;
  }
  .k-card-badge {
    left: calc(12px);
  }
  .k-card-second-badge {
    right: calc(12px);
  }
}
.k-card h2 {
  font-size: 20px;
  font-weight: 600;
}
.k-card .desc {
  font-size: 15px;
}
.k-card .tborder {
  border-top: var(--default-border);
}
.k-card .bpane {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.k-card .content {
  padding: 0 32px 32px 32px;
}
.ptb20 {
  padding: 20px 0;
}
.p20 {
  padding: 20px;
}
</style>